import React from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { Button, Card, Space, Typography } from 'antd';

const { Text } = Typography;

const PanelErrorFallback: React.FC<FallbackProps> = ({ error, resetErrorBoundary }) => {
  const cardActions = [
    <Card title="Error" size="small" style={{ borderColor: 'red' }}>
      <Text type="danger">Something went wrong.</Text>
      {process.env.NODE_ENV === 'development' && (
        <pre style={{ whiteSpace: 'pre-wrap', fontSize: '0.7em', marginTop: '8px' }}>
          {error instanceof Error ? error.message : String(error)}
        </pre>
      )}
      <Space style={{ marginTop: '10px' }}>
        <Button size="small" onClick={resetErrorBoundary}>Reset Error</Button>
      </Space>
    </Card>
  ];

  return <>{cardActions}</>;
};

export const PanelErrorBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ErrorBoundary FallbackComponent={PanelErrorFallback} onReset={() => { /* You could add reset logic here if needed */ }}>
    {children}
  </ErrorBoundary>
);